import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { STORE_DISCOUNT_TYPES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getStoreDiscountTypesAction = createAsyncThunk(
    'price/getStoreDiscountTypesAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ STORE_DISCOUNT_TYPES_PATH }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getStoreDiscountTypesSlice = createSlice({
    name: 'getStoreDiscountTypesSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getStoreDiscountTypesAction.pending, () => STATE__API__STARTED);
        builder.addCase(getStoreDiscountTypesAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getStoreDiscountTypesAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getStoreDiscountTypesState = (state) => state.price.getStoreDiscountTypes;
export default getStoreDiscountTypesSlice.reducer;
